module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn btn-default btn-xs",
    staticStyle: {
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.SelectAll($event)
      }
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-xs",
    staticStyle: {
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.DeselectAll($event)
      }
    }
  }, [_vm._v("Deselect All")]), _vm._v(" "), _c('div', {
    staticClass: "list-group pre-scrollable"
  }, _vm._l((_vm.selection), function(item, index) {
    return _c('a', {
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.OnSelect(index)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-10",
      class: {
        'text-primary': item.IsSelected
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "500",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(item.Object.firstName) + " " + _vm._s(item.Object.lastName))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm.FormatDate(item.Object.dob)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [(item.IsSelected) ? _c('span', {
      staticClass: "text-primary pull-right"
    }, [_c('i', {
      staticClass: "fa fa-check fa-1x"
    })]) : _vm._e()])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0766a70c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0766a70c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/PatientSelector/PatientSelector.scp.html
// module id = 445
// module chunks = 0